// Gutenberg block: labify/product-effects (frontend placeholder).
(() => {
  const el = document.querySelector(".wp-block-labify-product-effects, .c-product-effects");
  if (!el) return;
})();

